// Bundle module styles into shared CSS file
import './frontend.scss';
